// import React from "react";
// import "./Counter.css";
// import CountUp from "react-countup";

// const Counter = () => {
//   return (
//     <section className="Counter_sec">
//       <div className="container">
//         <div className="counter-bg-div">
//           <div className="row justify-content-center">
//             <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-0 ">
//               <div className="aligndiv">
//                 <p className="subtext"> Bus Stands :- </p>
//                 <h1>
//                   <CountUp
//                     className="count-text"
//                     delay={2}
//                     end={366}
//                     decimals={0}
//                   />
//                   {/* <span className="spank">K</span> */}
//                 </h1>
//               </div>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-0 ">
//               <div className="aligndiv">
//                 <p className="subtext"> Screens :-</p>
//                 <h1>
//                   <CountUp
//                     className="count-text"
//                     delay={2}
//                     end={1000}
//                     decimals={0}
//                   />
//                   {/* <span className="spank">K</span> */}
//                 </h1>
//               </div>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-0 ">
//               <div className="aligndiv">
//                 <p className="subtext"> Daily Slots :-</p>
//                 <h1>
//                   <CountUp
//                     className="count-text"
//                     delay={2}
//                     end={288000}
//                     decimals={0}
//                   />
//                   {/* <span className="spank">K</span> */}
//                 </h1>
//               </div>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-0 ">
//               <div className="aligndiv">
//                 <h1>
//                   <span className="spank">⏳ Live ETA Updates</span>
//                 </h1>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Counter;

import React from "react";
import { FaBus, FaTv, FaChartBar, FaClock } from "react-icons/fa";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Counter.css";

function Counter() {
  const stats = [
    { icon: <FaBus size={40} />, number: "366", label: "Bus Stands" },
    { icon: <FaTv size={40} />, number: "1000", label: "Digital Screens" },
    {
      icon: <FaChartBar size={40} />,
      number: "75 Lakh To 1.5 Crore ",
      label: "Daily Views",
    },
    { icon: <FaClock size={40} />, number: "Live ETA", label: "Bus Timetable" },
  ];

  return (
    <>
      <section className="counter-container">
        <Container fluid>
          <Row className="justify-content-center">
            {stats.map((item, index) => (
              <Col key={index} xs={12} sm={6} md={6}  lg={3} className="counter-col">
                <Card className="counter-card">
                  <Card.Body>
                    <div className="counter-icon">{item.icon}</div>
                    <Card.Title className="counter-number">
                      {item.number}
                    </Card.Title>
                    <div className="counter-underline"></div>
                    <Card.Text className="counter-label">
                      <span>{item.label.split(" ")[0]}</span>{" "}
                      {item.label.split(" ")[1]}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Counter;
